import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Menu, MenuItem, Radio } from '@material-ui/core';
import '../NewCustomer/NewCustomer.scss';
import { makeStyles } from '@material-ui/core/styles';
import { SvgList } from '../../components';
import Button from '../../components/Button';
import Popup from '../../components/Popup';
import { _showAlert } from '../../utils';
import { userActions } from '../../actions';
import { PLAN } from '../../constants/general.constant';
import { isEmpty, set } from 'lodash';

const useStyles = makeStyles({
  cancelButton: {
    borderRadius: 32,
    background: '#40189D',
    boxShadow: 'none',
    padding: '12px 28px',
  },
});

const calculateDaysLeft = (expiryDate) => {
  const timeDiff = expiryDate - new Date();
  return Math.ceil(timeDiff / (1000 * 60 * 60 * 24));
};

function getDaysLeft(timestamp) {
  const currentTime = Date.now(); // Get current time in milliseconds
  const futureTime = timestamp; // Provided timestamp in milliseconds

  // Calculate the difference in milliseconds between future and current time
  const timeDiff = futureTime - currentTime;

  // Convert milliseconds to days
  const millisecondsInADay = 1000 * 60 * 60 * 24;
  const daysLeft = Math.floor(timeDiff / millisecondsInADay);

  if (daysLeft < 0 || isNaN(daysLeft)) {
    return 0;
  }

  return daysLeft;
}

function PersonalDetails({ ...props }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const classes = useStyles();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(1);
  const [isEdit, setIsEdit] = useState(false);
  const [user, setUser] = useState({});
  const [selectedPlanType, setSelectedPlanType] = useState('');
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);

  const newCustomerData = useSelector((state) => state.newCustomer.result);

  const [confirmPopup, setconfirmPopup] = useState({
    isOpen: false,
    id: null,
  });
  const defaultFormState = {
    name: props?.userData?.name || '',
    businessName: props?.userData?.business_name || '',
    email: props?.userData?.email || '',
    phoneNumber: props?.userData?.phone_no || '',
    planType: props?.userData?.primium_type || '',
    planStatus: getDaysLeft(props?.userData?.primium_expiry_date) + ' days left',
    businessAddress: props?.userData?.business_address || '',
  };
  const [formFields, setFormFields] = useState(defaultFormState);
  const [togglePassword, setTogglePassword] = useState(true);
  const [errors, setErrors] = useState([]);
  const [readoOnlyFields, setReadOnlyFields] = useState({
    username: true,
    password: true,
  });

  const handleSubmit = (e) => {
    e.preventDefault();
  };

  const handleValidation = () => {
    let fields = formFields;
    let errors = {};
    let formIsValid = true;

    // bankname

    if (!fields['name']) {
      formIsValid = false;
      errors['name'] = 'Cannot be empty';
    }

    // if (isEmpty(fields['name'])) {
    //   formIsValid = false;
    //   errors['name'] = 'Cannot be empty';
    // }

    // accountNumber
    if (!fields['businessName']) {
      formIsValid = false;
      errors['businessName'] = 'Cannot be empty';
    }

    // accountHolderName
    // if (!fields['email']) {
    //   formIsValid = false;
    //   errors['email'] = 'Cannot be empty';
    // }

    // cinNumber
    // if (!fields['phoneNumber']) {
    //   formIsValid = false;
    //   errors['phoneNumber'] = 'Cannot be empty';
    // }

    // ibanNumber
    // if (!fields['planType']) {
    //   formIsValid = false;
    //   errors['planType'] = 'Cannot be empty';
    // }
    // Plan type
    if (!fields['planType'] || fields['planType'] === '') {
      errors['planType'] = 'Cannot be empty';
    }

    // swift
    if (!fields['businessAddress']) {
      formIsValid = false;
      errors['businessAddress'] = 'Cannot be empty';
    }

    // if (!fields['branch']) {
    //   formIsValid = false;
    //   errors['branch'] = 'Cannot be empty';
    // }

    setErrors(errors);
    if (!isEmpty(errors)) {
      return false;
    } else {
      return formIsValid;
    }
  };

  const handleMenuClick = (event) => {
    setMenuAnchorEl(event.currentTarget);
  };

  const handleInputChange = (event) => {
    let id = event.target.id;
    let value = event.target.value;
    setFormFields({ ...formFields, [id]: value });
    setErrors({ ...errors, [id]: '' });
  };

  const handleMenuItemClick = (event, option) => {
    setSelectedPlanType(option.value);
    setFormFields({ ...formFields, planType: option }); // Update the form field with the selected plan type
    setMenuAnchorEl(null);
  };

  useEffect(() => {
    const isFormEdited = Object.keys(defaultFormState).some((key) => formFields[key] !== defaultFormState[key]);
    setIsEdit(isFormEdited);
  }, [formFields]);

  const handleSave = async () => {
    if (Object.keys(errors).length === 0 && isEdit) {
      setIsEdit(false);
      setLoading(true);
      try {
        const fName = formFields.name.split(' ')[0];
        const lName = formFields.name.split(' ').slice(1).join(' ');

        const response = await userActions.updateUser(props?.userData?.id, {
          first_name: fName,
          last_name: lName,
          business_name: formFields.businessName,
          business_address: formFields.businessAddress,
          primium_type: selectedPlanType,
        });

        if (response?.code === 'OK') {
          setUser(response?.data);
          setLoading(false);
          setconfirmPopup({ isOpen: false, id: null });
          _showAlert('User updated successfully', 'success');
        } else {
          setLoading(false);
          setconfirmPopup({ isOpen: false, id: null });
          _showAlert('Something went wrong', 'error');
        }
      } catch (error) {
        setLoading(false);
        setconfirmPopup({ isOpen: false, id: null });
        console.error('Error during save:', error);
      }
    }
  };

  const handleSaveChanges = () => {
    if (isEdit) {
      const isValid = handleValidation();

      if ((errors && Object.keys(errors).length > 0) || isValid === false) {
        return;
      }

      if (defaultFormState.planType !== selectedPlanType) {
        setconfirmPopup({ isOpen: true, id: props?.userData?.id });
      } else {
        handleSave();
      }
    }
  };

  useEffect(() => {
    setFormFields((prevFormFields) => ({
      ...prevFormFields,
      name: props?.userData?.name || '',
      businessName: props?.userData?.business_name || '',
      email: props?.userData?.email || '',
      phoneNumber: props?.userData?.phone_no || '',
      planType: props?.userData?.primium_type || '',
      planStatus: getDaysLeft(props?.userData?.primium_expiry_date) + ' days left',
      businessAddress: props?.userData?.business_address || '',
    }));
    setSelectedPlanType(props?.userData?.primium_type === 'TRIAL' ? 'UNLIMITED' : props?.userData?.primium_type || '');
  }, [props?.userData]);

  return (
    <form
      style={{ height: '100%' }}
      onSubmit={(e) => {
        e.preventDefault();
        handleSaveChanges();
      }}
    >
      <div style={{ display: 'flex', flexDirection: 'column', height: '100%', flexWrap: 'wrap' }}>
        <div className="new_customer_row" style={{ height: '100%', overflow: 'auto' }}>
          <h5 style={{ marginBottom: 50 }}>personal details</h5>
          <div className="field_row">
            <div className="field_col">
              <label> Name</label>
              <input type="text" value={formFields.name} onChange={handleInputChange} id="name" />
              <span className="input-error-messages">{errors['name']}</span>
            </div>

            <div className="field_col">
              <label>Business Name</label>
              <input type="text" value={formFields.businessName} onChange={handleInputChange} id="businessName" />
              <span className="input-error-messages">{errors && errors['businessName']}</span>
            </div>

            <div className="field_col">
              <label>Email</label>
              <input type="text" value={formFields.email} readOnly id="email" disabled />
              <span className="input-error-messages">{errors && errors['email']}</span>
            </div>

            <div className="field_col">
              <label>Phone Number</label>
              <input type="text" value={formFields.phoneNumber} readOnly id="phoneNumber" disabled />
              <span className="input-error-messages">{errors && errors['phoneNumber']}</span>
            </div>

            <div className="field_col">
              <label>Plan Type</label>

              <div style={{ display: 'flex', position: 'absolute', columnGap: 15, left: 10, cursor: 'pointer' }}>
                <span style={{ fontWeight: 600 }}>{selectedPlanType || 'Select Plan Type'}</span>
                <div onClick={handleMenuClick}>
                  <SvgList name="switch-icon" />
                </div>
              </div>

              <input type="text" readOnly />

              <span className="input-error-messages">{errors && errors['planType']}</span>
            </div>

            <div className="field_col">
              <label>Plan Status</label>
              <input type="text" value={formFields.planStatus} readOnly id="planStatus" disabled />
              <span className="input-error-messages">{errors && errors['planStatus']}</span>
            </div>

            <div className="field_col description">
              <label>Business Address</label>
              <input type="text" value={formFields.businessAddress} onChange={handleInputChange} id="businessAddress" />
              <span className="input-error-messages">{errors && errors['businessAddress']}</span>
            </div>
          </div>

          <Menu
            id="type-menu"
            className="dropdown-menu"
            anchorEl={menuAnchorEl}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'left',
            }}
            transformOrigin={{
              horizontal: 'right',
            }}
            open={Boolean(menuAnchorEl)}
            onClose={() => setMenuAnchorEl(null)}
          >
            {PLAN.map((option, index) => (
              <MenuItem
                style={{ padding: '15px 24px' }}
                key={option}
                selected={option.value === selectedPlanType}
                onClick={(event) => handleMenuItemClick(event, option)}
              >
                <Radio checked={option.value === selectedPlanType} value="primary" label="Primary" color="primary" />
                {option.label}
              </MenuItem>
            ))}
          </Menu>

          <Button isLoading={loading} onClick={handleSaveChanges} className="round_btn" disabled={!isEdit}>
            Save Changes
          </Button>

          <Popup open={confirmPopup?.isOpen} onClose={() => !loading && setconfirmPopup({ isOpen: false, id: null })}>
            <h4 style={{ textAlign: 'center', marginBottom: 20, fontSize: 20, lineHeight: '32px', maxWidth: '60%', marginInline: 'auto' }}>
              Are you sure, you want to change this user’s plan?
            </h4>
            <div className="button-group" style={{ '--button-color': '#6900af' }}>
              <Button onClick={() => !loading && setconfirmPopup({ isOpen: false, id: null })} className="button transparent">
                Cancel
              </Button>

              <Button isLoading={loading} onClick={handleSave} className="button primary">
                Confirm
              </Button>
            </div>
          </Popup>
        </div>
      </div>
    </form>
  );
}

export default PersonalDetails;
